module.exports = __webpack_public_path__ + "img/rnd_pt_fine_bolts.prt.ac142c17.jpg";